import TreatmentQueue from 'locales/plus/en/dentist/treatmentsQueue.json'
import Treatments from 'locales/plus/en/dentist/treatments.json'
import vitalSign from 'locales/plus/en/dentist/treatmentsVital-sign.json'
import treatmentsDx from 'locales/plus/en/dentist/treatmentsDx.json'
import Summary from 'locales/plus/en/dentist/summary.json'
import Opd from 'locales/plus/en/dentist/opd.json'
import Tx from 'locales/plus/en/dentist/treatmentsTx.json'
import Product from 'locales/plus/en/dentist/treatmentsProduct.json'
import Emr from 'locales/plus/en/dentist/treatmentsEmr.json'
import TreatmentDocument from 'locales/plus/en/dentist/treatmentDocument.json'
import TxInformationBox from 'locales/plus/en/dentist/txInFormationBox.json'
import TreatmentsTxp from 'locales/plus/en/dentist/treatmentsTxp.json'
import TreatmentsTxc from 'locales/plus/en/dentist/treatmentsTxc.json'
import PdfStickerMed from 'locales/plus/en/dentist/pdfStickerMed.json'
import Xray from 'locales/plus/en/dentist/xray.json'
import PDFInvoice from 'locales/plus/en/dentist/pdfInvoice.json'

export const TreatmentEN = {
  ...TreatmentQueue,
  ...Treatments,
  ...vitalSign,
  ...treatmentsDx,
  ...Summary,
  ...Opd,
  ...Tx,
  ...Product,
  ...Emr,
  ...TreatmentDocument,
  ...TxInformationBox,
  ...TreatmentsTxp,
  ...TreatmentsTxc,
  ...PdfStickerMed,
  ...Xray,
  ...PDFInvoice
}
